import { render, staticRenderFns } from "./toBereleased.vue?vue&type=template&id=5eb27a04&"
import script from "./toBereleased.vue?vue&type=script&lang=js&"
export * from "./toBereleased.vue?vue&type=script&lang=js&"
import style0 from "./toBereleased.vue?vue&type=style&index=0&id=5eb27a04&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports